import React from "react";
import "./_ActionType.scss";
import { Tag, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

/**
 * Egress policies are allow-lists: the destinations listed are reachable and
 * everything else is refused. There is no deny rule to write.
 *
 * This used to render a Block / Allow pair. Block was `disabled`, Allow's
 * onClick was commented out, and the selection lived in local state that the
 * form never read and never submitted — so the control offered a choice that
 * did not exist and could not be made, under a required-field marker. It
 * invited an administrator to believe deny rules were supported.
 *
 * Stating the model is the honest version of the same information. If deny
 * semantics are ever implemented in the Squid ACL, this is where the control
 * comes back.
 */
function ActionType() {
  return (
    <div className="action_type">
      <label htmlFor="action_type">Action</label>
      <div className="btn_action">
        <Tag color="blue" style={{ margin: 0, padding: "4px 10px", fontSize: 13 }}>
          Allow-list
        </Tag>
        <Tooltip title="Desktops covered by this policy may reach the destinations listed above. Every other destination is refused by the proxy and dropped by the host firewall.">
          <span style={{ color: "#667085", fontSize: 12, display: "inline-flex", alignItems: "center", gap: 4 }}>
            All other destinations are blocked <InfoCircleOutlined />
          </span>
        </Tooltip>
      </div>
    </div>
  );
}

export default ActionType;
